import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { I18nextProvider } from 'react-i18next';
import i18n from '../lib/i18n';

import { AuthProvider } from '../context/AuthProvider';
import Layout from '../layouts/Layout';
import PersistLogin from '../components/PersistLogin';
import Missing from '../pages/Missing';

import { authRoutes } from '../routes/auth';
import { shopRoutes } from '../routes/shop';

// Styles
import 'react-toastify/dist/ReactToastify.css';
import '../assets/styles/index.scss';
import '../assets/styles/App.scss';
import '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free/css/all.min.css';

const queryClient = new QueryClient();

/**
 * Shop Entry Point
 * Desplegado en: a.mecanica.mx (reports project)
 * Solo incluye rutas de shop + auth
 */
function ShopApp() {
  return (
    <div data-theme="light">
      <QueryClientProvider client={queryClient}>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Layout />}>
            {authRoutes}

            <Route element={<PersistLogin />}>
              {shopRoutes}
            </Route>

            <Route path="/" element={<Navigate to="/auth/login" replace />} />
            <Route path="*" element={<Missing />} />
          </Route>
        </Routes>
      </QueryClientProvider>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <AuthProvider>
          <ShopApp />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
);
